import { createApiSlice } from "@common/common-slice/commonSlice";

import {
  CRUD_SKILL_CATEGORY,
  GET_SKILL_CATEGORY,
} from "@routes";

const apiConfig = [
  {
    name: "createSkillCategory",
    method: "post",
    url: CRUD_SKILL_CATEGORY,
    stateKey: "message",
  },
  {
    name: "getSkillCategory",
    method: "get",
    url: CRUD_SKILL_CATEGORY,
    stateKey: "data",
  },
  {
    name: "getSkillCategoryDetails",
    method: "get",
    url: GET_SKILL_CATEGORY,
    stateKey: "detailsData",
  },
  {
    name: "updateSkillCategory",
    method: "put",
    url: CRUD_SKILL_CATEGORY,
    stateKey: "message",
  },
  {
    name: "deleteSkillCategory",
    method: "delete",
    url: CRUD_SKILL_CATEGORY,
    stateKey: "message",
  },
];

const customReducers = {
  initialState: {
    generate: false,
    backlogLoading: false,
    data: [],
    detailsData: [],
    selectedData: {},
    selectedCatetogyData: {},
  },

  reducers: {
    skillCategorySelect: (state, action) => {
      state.selectedCatetogyData = action?.payload;
    },
  },

  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "skillCategory",
  apiConfig,
  customReducers,
);

const skillCategorySlice = slice;

export default skillCategorySlice.reducer;

export const {
  createSkillCategory,
  getSkillCategory,
  getSkillCategoryDetails,
  updateSkillCategory,
  deleteSkillCategory,
} = thunks;

export const {
  rowSelect,
  skillCategorySelect,
} = actions;